// IEEE 9-bus standard power grid model in PSSE 'raw file' format
import ieee9RawData from './ieee9bus.raw';

export const IEEE_9_BUS_RAW_DATA = ieee9RawData;
